// generated by genversion
export const version = '2.15.1';
